import React from "react";
import PropTypes from "prop-types";
import ftmlogo from "../assets/images/fresh-thyme-market-logo.png";
import {useLocation} from "react-router-dom";
import NotFound from "../components/notFound/NotFound";


const MFADeleted = ({ redirectUri }) => {
    const location = useLocation();
    if (location?.state?.action !== "unenroll-mfa") {
        return <NotFound/>
    }

    return (
        <main className="delete-container">
            <section
                className="delete-card"
                aria-labelledby="delete-title"
            >
                <a
                    href={redirectUri}
                    className="logo-link"
                    aria-label="Go to home page"
                >
                    <img
                        src={ftmlogo}
                        alt="Fresh Thyme Market logo"
                        className="logo-image"
                    />
                </a>

                <div className="delete-content">
                    <h1 id="delete-title" className="delete-title">
                        MFA Deleted
                    </h1>

                    <p className="delete-text">
                        Your account has been permanently deleted.
                    </p>

                    <p className="delete-text">
                        Add MFA in account settings page.
                    </p>

                    <a
                        href={redirectUri}
                        className="ok-button"
                    >
                        OK
                    </a>
                </div>
            </section>
        </main>
    );
};

MFADeleted.propTypes = {
    redirectUri: PropTypes.string
};

MFADeleted.defaultProps = {
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "/"
};

export default MFADeleted;